<template>
  <div
    class="card shadow m-3 position-fixed right-0 top-0 pb-2"
    style="z-index: 1"
    ref="close"
  >
    <div class="card-body d-flex align-items-center">
      <div
        :class="{ rotate: !complete }"
        class="
          mr-3
          rounded-round
          d-flex
          align-items-center
          justify-content-center
          p-2
          border-2 border-primary
          text-primary
        "
        style="width: 50px; height: 50px"
      >
        <i class="fa-solid fa-hourglass-half fa-2x" />
      </div>
      <div style="min-width: 250px;">
        <div
          class="progress rounded-round mb-2"
          style="height: 12px"
        >
          <div
            class="progress-bar bg-primary rounded-round"
            :style="`width:${progressBarWidth}%;`"
          />
        </div>
        <div>
          {{ $t('Unsplitting Shipment...') }}
        </div>
      </div>
      <button
        @click="closeProgress()"
        type="button"
        class="close align-self-start ml-2 mr-n1 mt-n2 text-muted"
      >
        <span>×</span>
      </button>
    </div>
    <div
      v-if="completeList"
      class="ml-3"
    >
      <a
        class="text-primary font-size-sm text-underline custom-hover"
      >
        <span>{{ $t('Response Message') }}</span> <i class="fa-light fa-angle-down" />
      </a>
    </div>
    <!-- showLog -->
    <div
      v-if="showLog"
      style="max-width: 320px;"
    >
      <div v-if="remappedItems">
        <div
          :class="['pl-0 pt-0 ml-3 mr-3']"
          style="max-height: 600px; overflow-x: hidden; overflow-y: auto;"
        >
          <div class="font-size-sm pt-1">
            <span>{{ $t("Message") }}: </span><span>{{ $t(remappedItems.message) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/services/endpoint/tenant.service";
window.Pusher = require('pusher-js');
import Cookies from "js-cookie";
export default {
    props: {
      unSplitShipmentId:{
        type: [Object, Array],
        default: undefined
      }
    },
    data() {
        const vm = this;
        return {
            closeModal: false,
            errorList: [],
            totalShipment: 0,
            countTracking: 0,
            complete: false,
            loop: '',
            countCreateTracking: 0,
            countProgress: 20,
            countchunk : 1,
            second : 0,
            refreshIntervalId : null,
            shipmentList : [],
            showLog: false,
            completeList: [],
            printRound: 0,
            user: JSON.parse(Cookies.get('user')),
            tenant: JSON.parse(Cookies.get('tenant')),
            countRound: 0,
        }
    },
    watch : {
      remappedItems(nVal, oVal) {
        if(nVal && this.countProgress >= 100){
          if(nVal.status){
            this.swalAlert('success');
            return;
          }
          if(!nVal.status){
            this.swalAlert('error');
            return;
          }
        }
      }
    },
    computed: {
      progressBarWidth() {
        return this.countTracking;
      },
      checkListReady() {
        return this.$store.state.shipment.checkListReady;
      },
      remappedItems() {
        return this.completeList.reduce((acc, item) => {
          acc.push({
            message: item.message,
            item: this.completeList,
            status: item.status
          });
          return acc;
        }, [])[0]; // เก็บเฉพาะ object เดียว
      }
    },
    methods: {
        closeProgress() {
          this.$store.dispatch("shipment/updateShipmentDataTable", true);
          this.$store.dispatch("shipment/isModalUnSplitShipment", false);
          window.Echo.leave('request.unsplitshipment.'+this.tenant.id+''+this.user.id);
          if (this.websocket) {
              this.websocket.close();
          }
          clearInterval(this.refreshIntervalId);
          this.$store.dispatch("shipment/isModalUnSplitShipment", false);
        },
        async generateLabelFunc(){
          let payload = this.$store.state.shipment.unSplitShipmentId;
          this.openWebsocket();         
          
          this.countTracking = 0
          this.countCreateTracking = 0
          this.countProgress = 1
          this.second = 0
          this.shipmentList = []
          this.errorList = []
          this.showLog = true;

          
          try {
              let response = await Api.ShipmentV2.postUnSplitShipments(payload);
              response = response.data;
              this.totalShipment = response.data.total;
              this.loop = Math.ceil(this.totalShipment / this.countchunk); //จำนวน loop
              if (!response.status) {
                  this.showLog = true;
              }
          } catch (err) {
              console.error(err,'err');
              let message = err.response.message ? err.response.message : err.response.statusText;
              response = {
                  status: false,
                  message: message
              }
              // this.showLogError = true;
              this.showLog = true;
          }
        },
        openWebsocket(){
          let vm = this;
          let ws = this.websocket = new WebSocket(process.env.WEBSOCKETS_GOQUEUE_URL);
          let userId = this.user.id;
          ws.onopen = function open() {
              console.log('onopen')
              ws.send(JSON.stringify({
              "data": {
                  "clientUid": `request.unsplitshipment${vm.tenant.id}${userId}`
              },
              "event": "subscribe"
              }));
          };

          vm.refreshIntervalId = setInterval(function () {
            if(vm.countProgress >= vm.countTracking){
              vm.countTracking++
            }
          }, 100);

          ws.onmessage = function incoming(message) {
            let data = JSON.parse(message.data)
            if (data.data.clientUid == `request.unsplitshipment${vm.tenant.id}${userId}` && data.event == `request.unsplitshipment`) {
              let e = data.data;
              if (e.status) {
                vm.shipmentList.push(e.shipmentId);
              }else{
                vm.errorList.push(e.shipmentId);
                vm.countProgress = 100;
                // vm.showLogError = true;
                vm.showLog = true;
                vm.complete = true;
              }
              vm.completeList.push({
                  shipment: e.shipmentId,
                  message: e.message,
                  status: e.status
              });

              vm.countProgress = 100;
              vm.countRound = Math.floor((vm.countProgress * vm.loop) / 100);
              vm.countCreateTracking = vm.shipmentList.length;
              // vm.countCreateTracking = vm.shipmentList.length;

            }
            if (data.data.clientUid == `request.unsplitshipment${vm.tenant.id}${userId}` && data.event === 'ping') {
              ws.send(JSON.stringify({
                "data": {
                  "clientUid": `request.unsplitshipment${vm.tenant.id}${userId}`
                },
                "event": `pong`
              }))
            }

            if(vm.countProgress >= 100){
              vm.countTracking = 100
              vm.complete = true
              if(vm.errorList.length > 0){
                // vm.showLogError = true;
                vm.showLog = true;
                vm.complete = true;
              }else{
                vm.showLog = true;
                setTimeout(() => {
                  vm.$swal
                    window.Echo.leave('request.unsplitshipment.'+vm.tenant.id+''+userId);
                    if (vm.websocket) {
                        vm.websocket.close();
                    }
                    clearInterval(vm.refreshIntervalId);
                }, 1000);
              }
            }
          }
        },
        swalAlert(action = null) {
          let title, message, toastr = ''
          let icon = 'success'

          if (action == 'success') {
            title = this.$t('Unsplit Shipment Success.')
            message = this.$t('The order will have only 1 shipment.')
            toastr = this.$t("Unsplit Shipment Success.")
          } else if (action == 'error') {
            title = `${this.$t('Error')} !`
            message = this.$t('Unsplit Shipment Failed.')
            icon = 'warning'
          }

          if (action) {
            this.$swal.fire({
              title: title,
              icon: icon,
              html: message,
              confirmButtonText: '<i class="fas fa-thumbs-up mr-2"></i>' + this.$t('Got It'),
              buttonsStyling: false,
              customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-light'
              },
              focusConfirm: false,
              allowOutsideClick: false,
              allowEscapeKey: false
            }).then((result) => {
              if (result.isConfirmed) {
                if (action == 'success') {
                  this.$toastr.s(toastr, "<i class='fa-solid fa-circle-check mr-2'></i>" + this.$t('Success'))
                  this.$store.dispatch("shipment/isModalUnSplitShipment", false);
                }
              }
              this.$store.dispatch("shipment/updateShipmentDataTable", true)
            })
          }
        },
    },
    mounted() {
      this.generateLabelFunc();
    },
    filters: {
    },
}
</script>

<style scoped>
a.custom-hover {
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/shipment/ModalProgressUnSplitShipment.vue